import Form3 from "../common/form/Form3";
import SimpleMap from "../common/map/SimpleMap";
const Contact = () => {
	return (
	<div className="">
		<div className="container">
			<h1><span className="color1">C</span><span className="color2">o</span><span className="color3">n</span><span className="color4">t</span><span className="color6">a</span><span className="color1">c</span><span className="color2">t</span> <span className="color1">U</span><span className="color2">s</span></h1>
		</div>
		{/*<!-- SECTION CONTENT START --> */}
	<div className="section-full p-t80 p-b50">
		<div className="container">
		
			<div className="section-content m-b50">
				<div className="row">
				
					{/* <!-- LOCATION BLOCK --> */}
					<div className="wt-box col-md-6">
						<h4 className="text-uppercase">Location</h4>
						<div className="wt-separator-outer m-b30">
						   <div className="wt-separator style-icon">
							   <i className="fa fa-leaf text-black"></i>
							   <span className="separator-left site-bg-primary"></span>
							   <span className="separator-right site-bg-primary"></span>
						   </div>                            
					   </div>
						<div className="gmap-outline m-b30">
							<SimpleMap width={'auto'} height={'300px'} />	
						</div>
					</div>
		
					{/* <!-- CONTACT FORM--> */}
					<div className="wt-box col-md-6">
						<h4 className="text-uppercase">Contact Form </h4>
						<div className="wt-separator-outer m-b30">
							<div className="wt-separator style-icon">
							   <i className="fa fa-leaf text-black"></i>
							   <span className="separator-left site-bg-primary"></span>
							   <span className="separator-right site-bg-primary"></span>
							</div>                            
						</div>
						
						<Form3 />
				
					</div>
					
				</div>
			</div>
			
			{/* <!-- CONTACT DETAIL BLOCK --> */}
			<div className="section-content ">
				<div className="row">
					<div className="wt-box col-md-12">
						<h4 className="text-uppercase">Contact Detail </h4>
						<div className="wt-separator-outer m-b30">
							<div className="wt-separator style-icon">
							   <i className="fa fa-leaf text-black"></i>
							   <span className="separator-left site-bg-primary"></span>
							   <span className="separator-right site-bg-primary"></span>
						   </div>                            
						</div>
						<div className="row">
						
							<div className="col-md-4 col-sm-12 m-b30">
								<div className="wt-icon-box-wraper center p-a30 bdr-2 bdr-gray-light">
									<div className="wt-icon-box-sm site-bg-primary m-b20"><span className="icon-cell text-white"><i className="fa fa-phone"></i></span></div>
									<div className="icon-content">
										<h5>Phone</h5>
										<p>{process.env.REACT_APP_SITE_CONTACT_NO}</p>
									</div>
								</div>
							</div>
							<div className="col-md-4 col-sm-12 m-b30">
								<div className="wt-icon-box-wraper center p-a30 bdr-2 bdr-gray-light">
									<div className="wt-icon-box-sm site-bg-primary m-b20"><span className="icon-cell text-white"><i className="fa fa-envelope"></i></span></div>
									<div className="icon-content">
										<h6>Email</h6>
										<p>{process.env.REACT_APP_EMAIL_ADDRESS}</p>
									</div>
								</div>
							</div>
							<div className="col-md-4 col-sm-12 m-b30">
								<div className="wt-icon-box-wraper center p-a30 bdr-2 bdr-gray-light">
									<div className="wt-icon-box-sm site-bg-primary m-b20"><span className="icon-cell text-white"><i className="fa fa-map-marker"></i></span></div>
									<div className="icon-content">
										<h5>Address</h5>
										<p>{process.env.REACT_APP_SITE_TITLE}, {process.env.REACT_APP_SITE_ADDRESS} </p>
									</div>
								</div>
							</div>
						
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
	
	
	{/*<!-- SECTION CONTENT END -->	*/}	
		
	</div>
	);
};
export default Contact;